export default __webpack_public_path__ + "img/91a4c8ee9ec210013885b354cc33efcb.svg";